import { put, select } from 'redux-saga/effects';
import { selectCallSessions, setIsConference } from '../../../state/callSessions/callSessionsSlice';
import getIsConference from '../../../utils/getIsConference';

export default function* updateIsConference() {
  const sessions = yield select(selectCallSessions);
  const isConf = getIsConference(sessions);
  yield put(setIsConference(isConf));
}
